module.exports = __webpack_public_path__ + "img/expovina_04(1).7e03051e.jpg";